import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { filter, map, tap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';

import * as GlobalActions from './global.actions';
import { CmsBusinessHoursService } from '@cms/components/business-hours';

@Injectable()
export class GlobalEffects {
  private readonly cmsBusinessHoursService = inject(CmsBusinessHoursService);

  /********************************
   * Loading
   ********************************/

  // showLoading
  showLoading$ = createEffect(() =>
    this.actions$.pipe(
      filter((action: any) => (action && action.showLoading ? action : false)),
      map((action) => GlobalActions.showLoading({ action })),
    ),
  );

  // hideLoading
  hideLoading$ = createEffect(() =>
    this.actions$.pipe(
      filter((action: any) => (action && action.hideLoading ? action : false)),
      map((action) => GlobalActions.hideLoading({ action })),
    ),
  );

  /********************************
   * Navigation
   ********************************/

  // navigationEnd
  // when a navigationEnd: scroll to top
  navigationEnd$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ROUTER_NAVIGATED),
        filter(
          (action: any) =>
            !action.payload.routerState.data?.keepScroll &&
            !this.router.getCurrentNavigation()?.extras?.state?.keepScroll,
        ),
        tap(() => {
          const container = window;
          if (container) {
            container.scrollTo({ top: 0 });
          }
        }),
      ),
    {
      dispatch: false,
    },
  );

  // triggerOnLoginLoadBusinessHours
  triggerOnLoginLoadBusinessHours$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GlobalActions.initOnLogin),
        tap(() => this.cmsBusinessHoursService.load()),
      ),
    {
      dispatch: false,
    },
  );

  /**
   * constructor
   *
   */
  constructor(
    private actions$: Actions,
    private router: Router,
  ) {}
}
